import { IPayloadNotification } from 'src/types/notification';

export const idNotification = 'common.routes.notification';
export const initPayloadNotification: IPayloadNotification = {
  after: '',
  limit: 20,
  type: '',
  placeOfOrigin: [],
};
